/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Format_MenuInputs */



/**
* | output |
* | --- |
* | "Format menu" |
*
* @param {Format_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const format_menu = /** @type {((inputs?: Format_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Format_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu format")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formatmenü")
	if (locale === "it") return /** @type {LocalizedString} */ ("Menu Formato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Меню форматирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Menú de formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("格式菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォーマットメニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारूप मेनू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatar menu")
	return /** @type {LocalizedString} */ ("Format menu")
});